import React, { useContext } from 'react'
import {
    Switch,
    Route
} from 'react-router-dom'
import TransferNumber from './transfer-number/TransferNumber'

import NumberPicker from 'number-picker'
import Link from '../../design-components/Link'
import { ChevronForwardIcon } from 'svg-icons/src'
import Typography from 'typography'
import { createStyles, makeStyles, Theme } from '@material-ui/core'
import LeadContext from '../../LeadContext'
import PageTitle from '../../PageTitle'

const useStyles = makeStyles((theme: Theme) => createStyles({
    footer: {
        marginTop: '25px',
        [theme.breakpoints.up('md')]: {
            maxWidth: 'none',
            flexWrap: 'nowrap'
        },
        color: '#364047',
        '& svg': {
            width: '18px',
            height: '18px'
        }
    },
    footerLink: {
        display: 'block',
        [theme.breakpoints.up('md')]: {
            display: 'inline'
        }
    }
}))

const basePath = '/pick-a-number'

/**
 * Pick a number step of sign-up
 */
const PickANumber = () : JSX.Element => {
    const classes = useStyles()

    const leadContextValue = useContext(LeadContext)

    const { cart } = leadContextValue.leadParams

    let numberPickerErrorMessage = null
    if (cart?.some(item => item.status === 'number_expired')) {
        numberPickerErrorMessage = 'number_expired'
    } else if (cart?.some(item => item.status !== 'number_available')) {
        numberPickerErrorMessage = 'cart_number_not_available'
    }

    return (
        <Switch>
            <Route exact path={basePath}>
                <>
                    <PageTitle remoteConfigID="signup_select_number_title" />

                    <NumberPicker
                        recommendANumber={true}
                        errorMessage={numberPickerErrorMessage}
                    />

                    <Typography variant="body2" align="center" className={classes.footer}>
                        Already have a number you love?{' '}
                        <Link className={classes.footerLink} to="/pick-a-number/transfer">
                            Transfer your number to Phone.com<ChevronForwardIcon />
                        </Link>
                    </Typography>
                </>
            </Route>
            <Route path={`${basePath}/transfer`}>
                <TransferNumber />
            </Route>
        </Switch>
    )
}

export default PickANumber
